"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trtcJsSdk = _interopRequireDefault(require("trtc-js-sdk"));
var _libGenerateTestUsersigMin = _interopRequireDefault(require("../utils/lib-generate-test-usersig.min.js"));
/*
 * @Description: 屏幕分享
 * @Date: 2022-03-16 10:34:54
 * @LastEditTime: 2022-04-01 11:57:06
 */
var _default = {
  data: function data() {
    return {
      shareClient: null,
      shareLocalStream: null,
      isShareJoined: false,
      isSharePublished: false
    };
  },
  computed: {
    shareUserId: function shareUserId() {
      return "share_".concat(this.userId);
    },
    shareUserSig: function shareUserSig() {
      if (this.sdkAppId && this.secretKey && this.shareUserId) {
        var generator = new _libGenerateTestUsersigMin.default(this.sdkAppId, this.secretKey, 604800);
        return generator.genTestUserSig(this.shareUserId);
      }
      return '';
    }
  },
  methods: {
    // 初始化屏幕分享 client
    initShareClient: function initShareClient() {
      this.shareClient = _trtcJsSdk.default.createClient({
        mode: 'rtc',
        sdkAppId: this.sdkAppId,
        userId: this.shareUserId,
        userSig: this.shareUserSig,
        autoSubscribe: false
      });
      this.addSuccessLog("Client [".concat(this.shareUserId, "] created."));
      this.handleShareClientEvents();
    },
    // 初始化屏幕分享 stream
    initShareLocalStream: function () {
      var _initShareLocalStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.shareLocalStream = _trtcJsSdk.default.createStream({
                screenAudio: false,
                screen: true,
                userId: this.shareUserId
              });
              this.shareLocalStream.setScreenProfile('1080p');
              _context.prev = 2;
              _context.next = 5;
              return this.shareLocalStream.initialize();
            case 5:
              this.addSuccessLog("ShareStream [".concat(this.shareUserId, "] initialized."));
              _context.next = 19;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              this.addFailedLog("ShareStream failed to initialize. Error: ".concat(_context.t0.message, "}"));
              _context.t1 = _context.t0.name;
              _context.next = _context.t1 === 'NotReadableError' ? 14 : _context.t1 === 'NotAllowedError' ? 16 : 18;
              break;
            case 14:
              alert('屏幕分享失败，请确保系统允许当前浏览器获取屏幕内容');
              throw _context.t0;
            case 16:
              if (_context.t0.message.includes('Permission denied by system')) {
                alert('屏幕分享失败，请确保系统允许当前浏览器获取屏幕内容');
              } else {
                console.log('User refused to share the screen');
              }
              throw _context.t0;
            case 18:
              return _context.abrupt("return");
            case 19:
              this.handleShareStreamEvents();
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 8]]);
      }));
      function initShareLocalStream() {
        return _initShareLocalStream.apply(this, arguments);
      }
      return initShareLocalStream;
    }(),
    // 销毁本地屏幕分享流
    destroyShareLocalStream: function destroyShareLocalStream() {
      this.shareLocalStream.stop();
      this.shareLocalStream.close();
      this.shareLocalStream = null;
    },
    // 处理屏幕分享 client 进房
    handleShareJoin: function () {
      var _handleShareJoin = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isShareJoined) {
                _context2.next = 3;
                break;
              }
              console.error('ShareClient has joined');
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return this.shareClient.join({
                roomId: this.roomId
              });
            case 6:
              this.isShareJoined = true;
              this.addSuccessLog("ShareClient [".concat(this.shareUserId, "] join success."));
              _context2.next = 15;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              console.log('shareRTC handleJoin error', _context2.t0);
              this.addFailedLog("ShareClient [".concat(this.shareUserId, "] join failed. ").concat(_context2.t0.message));
              this.reportFailedEvent('startScreenShare', _context2.t0, 'share');
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 10]]);
      }));
      function handleShareJoin() {
        return _handleShareJoin.apply(this, arguments);
      }
      return handleShareJoin;
    }(),
    // 屏幕分享 client 发布屏幕分享流
    handleSharePublish: function () {
      var _handleSharePublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isSharePublished) {
                _context3.next = 3;
                break;
              }
              console.error('ShareClient has published');
              return _context3.abrupt("return");
            case 3:
              _context3.prev = 3;
              _context3.next = 6;
              return this.shareClient.publish(this.shareLocalStream);
            case 6:
              this.isSharePublished = true;
              this.addSuccessLog('ShareStream is published successfully.');
              this.reportSuccessEvent('startScreenShare', 'share');
              _context3.next = 15;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](3);
              this.addFailedLog("ShareStream is published failed. ".concat(_context3.t0.message));
              this.reportFailedEvent('startScreenShare', _context3.t0, 'share');
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 11]]);
      }));
      function handleSharePublish() {
        return _handleSharePublish.apply(this, arguments);
      }
      return handleSharePublish;
    }(),
    handleShareUnpublish: function () {
      var _handleShareUnpublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.isSharePublished) {
                _context4.next = 3;
                break;
              }
              console.error('ShareStream has not published');
              return _context4.abrupt("return");
            case 3:
              _context4.prev = 3;
              _context4.next = 6;
              return this.shareClient.unpublish(this.shareLocalStream);
            case 6:
              this.isSharePublished = false;
              this.addSuccessLog('ShareStream is unpublished successfully.');
              _context4.next = 15;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              console.log("ShareStream unpublish failed, ".concat(_context4.t0.message));
              this.addFailedLog("ShareStream unpublish failed, ".concat(_context4.t0.message, "."));
              this.reportFailedEvent('stopScreenShare', _context4.t0, 'share');
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 10]]);
      }));
      function handleShareUnpublish() {
        return _handleShareUnpublish.apply(this, arguments);
      }
      return handleShareUnpublish;
    }(),
    handleShareLeave: function () {
      var _handleShareLeave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.isShareJoined) {
                _context5.next = 3;
                break;
              }
              console.error('ShareStream has not joined');
              return _context5.abrupt("return");
            case 3:
              this.destroyShareLocalStream();
              _context5.prev = 4;
              _context5.next = 7;
              return this.shareClient.leave();
            case 7:
              this.isShareJoined = false;
              this.addSuccessLog('ShareClient leave successfully.');
              this.reportSuccessEvent('stopScreenShare', 'share');
              _context5.next = 17;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](4);
              console.log("ShareClient leave failed, ".concat(_context5.t0.message));
              this.addFailedLog("ShareClient leave failed, ".concat(_context5.t0.message));
              this.reportFailedEvent('stopScreenShare', _context5.t0, 'share');
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 12]]);
      }));
      function handleShareLeave() {
        return _handleShareLeave.apply(this, arguments);
      }
      return handleShareLeave;
    }(),
    handleShareClientEvents: function handleShareClientEvents() {
      this.shareClient.on('error', function (error) {
        console.error(error);
        alert(error);
      });
      this.shareClient.on('client-banned', function (error) {
        console.error("client has been banned for ".concat(error));
      });
    },
    handleShareStreamEvents: function handleShareStreamEvents() {
      var _this = this;
      this.shareLocalStream.on('player-state-changed', function (event) {
        console.log("local stream ".concat(event.type, " player is ").concat(event.state));
      });
      // 当用户通过浏览器自带的按钮停止屏幕分享时，会监听到 screen-sharing-stopped 事件
      this.shareLocalStream.on('screen-sharing-stopped', function () {
        console.log('share stream video track ended');
        _this.addSuccessLog('ScreenShare is stopped');
        _this.handleShareLeave();
      });
    }
  }
};
exports.default = _default;